import { Pipe, PipeTransform } from '@angular/core';
import { MenuItemDto } from '../../../services/akita/menu-item-schema/menu-item.dto';

@Pipe({
  name: 'getMenuDisabled'
})
export class GetMenuDisabledPipe implements PipeTransform {

  transform(menuDto: MenuItemDto, menuDtos: MenuItemDto[]): string {

    if (!menuDto.menuItem.data.page) {
      return 'disabled';
    } else if (!menuDto.menuItem.data.page.iv) {
      return 'disabled';
    }
    return '';

  }
}
